import { Paragraph } from "types/Paragraph";
import { RevisionAnnotations } from "types/RevisionAnnotation";

export const useClipboardParagraphGenerator = (
  paragraph: Paragraph,
  annotationMap: { [key: number]: RevisionAnnotations },
  annotationParagraphMap: { [key: string]: RevisionAnnotations },
  endLineAnnotations: { [key: string]: RevisionAnnotations },
  previousParagraphCollectionRef: string | undefined,
  commentColor: number[],
  isOSS: boolean
) => {
  const container = document.createElement("div");
  const deferredAnnotations: RevisionAnnotations = [];

  let assignmentParagraphs = [] as any[];

  if (
    isOSS &&
    paragraph.collectionRef == "paragraphs" &&
    paragraph.localIndex == 0
  ) {
    const header = document.createElement("span");
    header.innerText = "Writing Assignment";
    header.style.fontSize = "32px";
    header.style.fontWeight = "bold";
    assignmentParagraphs.push(header);
  }

  // assignmentParagraphs.push({ text: "", pageBreak: "before" });

  const paragraphTokenGroups = useConvertTokensToGroups(paragraph.tokens);

  let alignment: string = "left";
  const spacing = paragraph.formatting.lineSpacing;

  switch (paragraph.formatting.alignment) {
    case "CENTER":
      alignment = "center";
      break;
    case "RIGHT":
      alignment = "right";
      break;
    case "JUSTIFIED":
      alignment = "justified";
      break;
    case "LEFT":
    default:
      alignment = "left";
  }

  let didAddParagraphAnnotation = false;

  let previousTokenRunSpan: HTMLSpanElement | undefined = undefined;
  let previousTokenRunSpanFormatting: ParagraphTokenFormatting | undefined =
    undefined;

  for (const tokenGroup of paragraphTokenGroups) {
    const textRuns = [] as any[];

    if (
      paragraph.formatting.firstLineIndent ||
      paragraph.tokens[0]?.type == "space"
    ) {
      // indent span
      const indentSpan = document.createElement("span");
      indentSpan.innerText = "\u200B\t";
      textRuns.push(indentSpan);
    }

    for (const token of tokenGroup) {
      if (token.type == "page_break") {
        const pageBreak = document.createElement("div");
        pageBreak.innerText = "";
        pageBreak.style.pageBreakBefore = "always";
        textRuns.push(pageBreak);

        continue;
      }

      const fontSize: number = token.formatting?.size ?? 12;
      const textRun = useConvertTokenToPDFText(token, alignment, spacing);

      let tokenSpan: HTMLSpanElement | undefined =
        document.createElement("span");
      tokenSpan.innerText = textRun.text;
      tokenSpan.style.cssText = useConvertTokenToStyleFormatting(
        token.formatting,
        alignment,
        spacing
      );

      let preAnnotationRuns: any[] = [];
      let postAnnotationRuns: any[] = [];

      const idAnnotations = annotationMap[token.globalPosition];

      if (idAnnotations) {
        for (var an of idAnnotations) {
          if (an) {
            // @ts-ignore
            let annotationTextRuns = useConvertQuillDeltaToSpans(
              an.commentObject,
              fontSize,
              useRGBToHex(commentColor),
              false
            ).flat();

            if (useIsAnnotationCommentLong(an)) {
              deferredAnnotations.push(an);

              const seeBelowSpan = document.createElement("span");
              seeBelowSpan.innerText = " See below.";
              seeBelowSpan.style.fontSize = `${fontSize}pt`;
              seeBelowSpan.style.color = useRGBToHex(commentColor);
              seeBelowSpan.style.textAlign = "left";

              annotationTextRuns = [seeBelowSpan];
            }
            const textRun = useConvertTokenToPDFText(token, alignment, spacing);

            let tokenSpan: HTMLSpanElement | undefined =
              document.createElement("span");
            tokenSpan.innerText = textRun.text;
            tokenSpan.style.cssText = useConvertTokenToStyleFormatting(
              token.formatting,
              alignment,
              spacing
            );

            // We want ot check if the token.formatting is the same as the previousTokenRunSpanFormatting. These are objects with key value pairs.
            // If they are the same and there is a previous token run we'll add the text to the previous span
            // This is to reduce the amount of spans that we have to create.
            if (
              previousTokenRunSpan != undefined &&
              previousTokenRunSpanFormatting != undefined &&
              useIsEqualParagraphTokenFormatting(
                previousTokenRunSpanFormatting,
                token.formatting
              )
            ) {
              previousTokenRunSpan.innerText += tokenSpan.innerText;
              tokenSpan = undefined;
            } else {
              previousTokenRunSpan = tokenSpan;
              previousTokenRunSpanFormatting = token.formatting;
            }

            let preAnnotationRuns: any[] = [];
            let postAnnotationRuns: any[] = [];

            const idAnnotations = annotationMap[token.globalPosition];

            if (idAnnotations) {
              for (var an of idAnnotations) {
                if (an) {
                  // @ts-ignore
                  let annotationTextRuns = useConvertQuillDeltaToSpans(
                    an.commentObject,
                    fontSize,
                    useRGBToHex(commentColor),
                    false
                  ).flat();

                  if (useIsAnnotationCommentLong(an)) {
                    deferredAnnotations.push(an);

                    const seeBelowSpan = document.createElement("span");
                    seeBelowSpan.innerText = " See below.";
                    seeBelowSpan.style.fontSize = `${fontSize}pt`;
                    seeBelowSpan.style.color = useRGBToHex(commentColor);
                    seeBelowSpan.style.textAlign = "left";

                    annotationTextRuns = [seeBelowSpan];
                  }

                  // if (token.type == "filler" || token.type == "space") {

                  //     const fillerSpan = document.createElement('span');
                  //     fillerSpan.innerText = " ";
                  //     fillerSpan.style.fontSize = `${fontSize}pt`;
                  //     fillerSpan.style.color = useRGBToHex(commentColor);
                  //     fillerSpan.style.textAlign = "left";

                  //     annotationTextRuns.push(fillerSpan);
                  // } else {
                  //     const fillerSpan = document.createElement('span');
                  //     fillerSpan.innerText = " ";
                  //     fillerSpan.style.fontSize = `${fontSize}pt`;
                  //     fillerSpan.style.color = useRGBToHex(commentColor);
                  //     fillerSpan.style.textAlign = "left";

                  //     annotationTextRuns = [fillerSpan, ...annotationTextRuns];
                  // }

                  // If the annotation is only attached to one token then we put the annotation before the token
                  // Other wise we'll render the annotations after the last token

                  // IEW requested annotations always come after so I'm doing htat here but will leae in the old code.
                  if (
                    (an.tokenGlobalPositions.length > 1 ||
                      an.forceAfterToken ||
                      true) &&
                    an.isStartLine != true
                  ) {
                    if (token.type != "filler" && token.type != "space") {
                      const fillerSpan = document.createElement("span");
                      fillerSpan.innerText = " ";
                      fillerSpan.style.fontSize = `${fontSize}pt`;
                      fillerSpan.style.color = useRGBToHex(commentColor);
                      fillerSpan.style.textAlign = "left";

                      annotationTextRuns = [fillerSpan, ...annotationTextRuns];
                    }

                    postAnnotationRuns.push(...annotationTextRuns);
                  }

                  if (an.isStartLine == true) {
                    preAnnotationRuns.push(...annotationTextRuns);
                  }
                }
              }
            }

            const indexOfToken = tokenGroup.indexOf(token);
            const isLastTokenInGroup = indexOfToken == tokenGroup.length - 1;

            const paragraphEndLineAnnotations =
              endLineAnnotations[paragraph.id];

            if (isLastTokenInGroup && paragraphEndLineAnnotations) {
              for (var an of paragraphEndLineAnnotations) {
                if (an) {
                  // If the annotation is attached to the last token of a particular group and
                  // that value doesn't match this last token, skip over attachign this annotation.
                  if (
                    an.lastTokenGlobalPosition &&
                    an.lastTokenGlobalPosition != token.globalPosition
                  ) {
                    continue;
                  }

                  // @ts-ignore
                  let annotationTextRuns = useConvertQuillDeltaToSpans(
                    an.commentObject,
                    fontSize,
                    useRGBToHex(commentColor),
                    false
                  ).flat();

                  if (useIsAnnotationCommentLong(an)) {
                    deferredAnnotations.push(an);

                    const seeBelowSpan = document.createElement("span");
                    seeBelowSpan.innerText = " See below.";
                    seeBelowSpan.style.fontSize = `${fontSize}pt`;
                    seeBelowSpan.style.color = useRGBToHex(commentColor);
                    seeBelowSpan.style.lineHeight = "1.5";
                    seeBelowSpan.style.textAlign = "left";

                    annotationTextRuns = [seeBelowSpan];
                  }

                  postAnnotationRuns.push(...annotationTextRuns);
                }
              }
            }

            if (preAnnotationRuns.length > 0) {
              textRuns.push(...preAnnotationRuns);
            }

            if (tokenSpan != undefined) {
              textRuns.push(tokenSpan);
            }

            if (postAnnotationRuns.length > 0) {
              textRuns.push(...postAnnotationRuns);
            }

            preAnnotationRuns = [];
            postAnnotationRuns = [];
          }

          if (paragraph.formatting.leftIndent) {
            const indentSpan = document.createElement("span");
            indentSpan.innerText = "\u200B\t";
            textRuns.push(indentSpan);
          }

          const paragraphDiv = document.createElement("div");
          paragraphDiv.style.textAlign = alignment;
          paragraphDiv.style.lineHeight =
            paragraph.formatting.lineSpacing?.toString() ?? "2.0";

          for (const textRun of textRuns) {
            paragraphDiv.appendChild(textRun);
          }

          assignmentParagraphs.push(paragraphDiv);

          // Now we insert deferred annotations or extra annotaitons

          // Here we insert any deffered annotations or paragraph annotaitons between token groups as necessary
          const paragraphId = paragraph.id;

          for (const deferredAnnotation of deferredAnnotations) {
            deferredAnnotation.tokenGlobalPositions.sort();

            if (deferredAnnotation.tokenGlobalPositions.length == 0) continue;

            const lastTokenPosition =
              deferredAnnotation.tokenGlobalPositions[
                deferredAnnotation.tokenGlobalPositions.length - 1
              ];

            const indexInGroup = tokenGroup.findIndex(
              (t) => t.globalPosition == lastTokenPosition
            );

            // If the deferred annotqtion is not linked to this particualr group then we need to skip
            if (indexInGroup < 0) continue;

            const deferredAnnotationRuns: any[] = [];

            const newLineSpan = document.createElement("div");
            newLineSpan.innerText = "\n";
            newLineSpan.style.fontSize = `${12}pt`;
            newLineSpan.style.color = useRGBToHex(commentColor);
            newLineSpan.style.textAlign = "left";

            deferredAnnotationRuns.push(newLineSpan);

            const tokenText = deferredAnnotation.tokenText;

            if (tokenText != "") {
              const tokenTextSpan = document.createElement("span");
              tokenTextSpan.innerText = `${tokenText} - `;
              tokenTextSpan.style.fontSize = `${12}pt`;
              tokenTextSpan.style.color = useRGBToHex(commentColor);
              tokenTextSpan.style.textAlign = "left";

              deferredAnnotationRuns.push(tokenTextSpan);
            }

            let annotationTextRuns = useConvertQuillDeltaToSpans(
              deferredAnnotation.commentObject,
              12,
              useRGBToHex(commentColor),
              true
            )
              .flat()
              .filter((r) => r.text != "");

            // const lineBreakSpan = document.createElement('span');
            // lineBreakSpan.innerText = "\n";
            // lineBreakSpan.style.fontSize = `${12}pt`;
            // lineBreakSpan.style.color = useRGBToHex(commentColor);
            // lineBreakSpan.style.textAlign = "left";

            // annotationTextRuns.push(lineBreakSpan);

            // Add a line break after the annotation

            deferredAnnotationRuns.push(...annotationTextRuns);

            // for (const run of deferredAnnotationRuns) {
            //     const annotationDivWrapper = document.createElement('div');
            //     annotationDivWrapper.appendChild(run);

            //     assignmentParagraphs.push(annotationDivWrapper);
            // }

            // If the annotation is only attached to one token then we put the annotation before the token
            // Other wise we'll render the annotations after the last token

            // IEW requested annotations always come after so I'm doing htat here but will leae in the old code.
            if (
              (an.tokenGlobalPositions.length > 1 ||
                an.forceAfterToken ||
                true) &&
              an.isStartLine != true
            ) {
              if (token.type != "filler" && token.type != "space") {
                const fillerSpan = document.createElement("span");
                fillerSpan.innerText = " ";
                fillerSpan.style.fontSize = `${fontSize}pt`;
                fillerSpan.style.color = useRGBToHex(commentColor);
                fillerSpan.style.textAlign = "left";

                annotationTextRuns = [fillerSpan, ...annotationTextRuns];
              }

              postAnnotationRuns.push(...annotationTextRuns);
            }

            if (an.isStartLine == true) {
              preAnnotationRuns.push(...annotationTextRuns);
            }
          }
        }
      }

      const indexOfToken = tokenGroup.indexOf(token);
      const isLastTokenInGroup = indexOfToken == tokenGroup.length - 1;

      const paragraphEndLineAnnotations = endLineAnnotations[paragraph.id];

      if (isLastTokenInGroup && paragraphEndLineAnnotations) {
        for (var an of paragraphEndLineAnnotations) {
          if (an) {
            // If the annotation is attached to the last token of a particular group and
            // that value doesn't match this last token, skip over attachign this annotation.
            if (
              an.lastTokenGlobalPosition &&
              an.lastTokenGlobalPosition != token.globalPosition
            ) {
              continue;
            }

            // @ts-ignore
            let annotationTextRuns = useConvertQuillDeltaToSpans(
              an.commentObject,
              fontSize,
              useRGBToHex(commentColor),
              false
            ).flat();

            if (useIsAnnotationCommentLong(an)) {
              deferredAnnotations.push(an);

              const seeBelowSpan = document.createElement("span");
              seeBelowSpan.innerText = " See below.";
              seeBelowSpan.style.fontSize = `${fontSize}pt`;
              seeBelowSpan.style.color = useRGBToHex(commentColor);
              seeBelowSpan.style.lineHeight = "1.5";
              seeBelowSpan.style.textAlign = "left";

              annotationTextRuns = [seeBelowSpan];
            }

            postAnnotationRuns.push(...annotationTextRuns);
          }
        }
      }

      // We want ot check if the token.formatting is the same as the previousTokenRunSpanFormatting. These are objects with key value pairs.
      // If they are the same and there is a previous token run we'll add the text to the previous span
      // This is to reduce the amount of spans that we have to create.
      if (
        previousTokenRunSpan != undefined &&
        previousTokenRunSpanFormatting != undefined &&
        useIsEqualParagraphTokenFormatting(
          previousTokenRunSpanFormatting,
          token.formatting
        ) &&
        (preAnnotationRuns.length > 0 || postAnnotationRuns.length > 0)
      ) {
        previousTokenRunSpan.innerText += tokenSpan.innerText;
        tokenSpan = undefined;
      } else {
        previousTokenRunSpan = tokenSpan;
        previousTokenRunSpanFormatting = token.formatting;
      }

      if (preAnnotationRuns.length > 0) {
        textRuns.push(...preAnnotationRuns);
      }

      if (tokenSpan != undefined) {
        textRuns.push(tokenSpan);
      }

      if (postAnnotationRuns.length > 0) {
        textRuns.push(...postAnnotationRuns);
      }

      preAnnotationRuns = [];
      postAnnotationRuns = [];
    }

    if (paragraph.formatting.leftIndent) {
      const indentSpan = document.createElement("span");
      indentSpan.innerText = "\u200B\t";
      textRuns.push(indentSpan);
    }

    const paragraphDiv = document.createElement("div");
    paragraphDiv.style.textAlign = alignment;
    paragraphDiv.style.lineHeight =
      paragraph.formatting.lineSpacing?.toString() ?? "1.0";

    for (const textRun of textRuns) {
      paragraphDiv.appendChild(textRun);
    }

    assignmentParagraphs.push(paragraphDiv);

    // Now we insert deferred annotations or extra annotaitons

    // Here we insert any deffered annotations or paragraph annotaitons between token groups as necessary
    const paragraphId = paragraph.id;

    for (const deferredAnnotation of deferredAnnotations) {
      deferredAnnotation.tokenGlobalPositions.sort();

      if (deferredAnnotation.tokenGlobalPositions.length == 0) continue;

      const lastTokenPosition =
        deferredAnnotation.tokenGlobalPositions[
          deferredAnnotation.tokenGlobalPositions.length - 1
        ];

      const indexInGroup = tokenGroup.findIndex(
        (t) => t.globalPosition == lastTokenPosition
      );

      // If the deferred annotqtion is not linked to this particualr group then we need to skip
      if (indexInGroup < 0) continue;

      const deferredAnnotationRuns: any[] = [];

      const newLineSpan = document.createElement("div");
      newLineSpan.innerText = "\n";
      newLineSpan.style.fontSize = `${12}pt`;
      newLineSpan.style.color = useRGBToHex(commentColor);
      newLineSpan.style.textAlign = "left";

      deferredAnnotationRuns.push(newLineSpan);

      const tokenText = deferredAnnotation.tokenText;

      if (tokenText != "") {
        const tokenTextSpan = document.createElement("span");
        tokenTextSpan.innerText = `${tokenText} - `;
        tokenTextSpan.style.fontSize = `${12}pt`;
        tokenTextSpan.style.color = useRGBToHex(commentColor);
        tokenTextSpan.style.textAlign = "left";

        deferredAnnotationRuns.push(tokenTextSpan);
      }

      const annotationTextRuns = useConvertQuillDeltaToSpans(
        deferredAnnotation.commentObject,
        12,
        useRGBToHex(commentColor),
        true
      )
        .flat()
        .filter((r) => r.text != "");

      // const lineBreakSpan = document.createElement('span');
      // lineBreakSpan.innerText = "\n";
      // lineBreakSpan.style.fontSize = `${12}pt`;
      // lineBreakSpan.style.color = useRGBToHex(commentColor);
      // lineBreakSpan.style.textAlign = "left";

      // annotationTextRuns.push(lineBreakSpan);

      // Add a line break after the annotation

      deferredAnnotationRuns.push(...annotationTextRuns);

      // for (const run of deferredAnnotationRuns) {
      //     const annotationDivWrapper = document.createElement('div');
      //     annotationDivWrapper.appendChild(run);

      //     assignmentParagraphs.push(annotationDivWrapper);
      // }

      assignmentParagraphs.push(...deferredAnnotationRuns);

      if (deferredAnnotationRuns.length > 0) {
        didAddParagraphAnnotation = true;
      }
    }

    const paragraphAnnotations = annotationParagraphMap[paragraphId] ?? [];

    for (const an of paragraphAnnotations) {
      // if we have a lasttokenglobalPosition then we need to check if it's in this group
      // If the lastTokenglobalposition for this annotation isn't in this group then we skip it.
      if (an.lastTokenGlobalPosition) {
        const index = tokenGroup.findIndex(
          (t) => t.globalPosition == an.lastTokenGlobalPosition
        );

        if (index < 0) continue;
      }

      const deferredAnnotationRuns: any[] = [];

      // Add a line break after the annotation
      const newLineSpan = document.createElement("span");
      newLineSpan.innerText = "\n";
      newLineSpan.style.fontSize = `${12}pt`;
      newLineSpan.style.color = useRGBToHex(commentColor);
      newLineSpan.style.textAlign = "left";

      deferredAnnotationRuns.push(newLineSpan);

      const annotationTextRuns = useConvertQuillDeltaToSpans(
        an.commentObject,
        12,
        useRGBToHex(commentColor),
        true
      )
        .flat()
        .filter((r) => r.text != "");

      deferredAnnotationRuns.push(...annotationTextRuns);

      // for (const run of deferredAnnotationRuns) {
      //     assignmentParagraphs.push(run);
      // }

      if (an.isBeforeParagraph == true) {
        var startParagraphLineBreakSpan = document.createElement("span");
        startParagraphLineBreakSpan.innerText = "\n";

        assignmentParagraphs = [
          ...deferredAnnotationRuns,
          startParagraphLineBreakSpan,
          ...assignmentParagraphs,
        ];
      } else {
        assignmentParagraphs.push(...deferredAnnotationRuns);

        if (deferredAnnotationRuns.length > 0) {
          didAddParagraphAnnotation = true;
        }
      }
    }
  }

  for (const paragraph of assignmentParagraphs) {
    container.appendChild(paragraph);
  }

  if (didAddParagraphAnnotation) {
    const lineBreakSpan = document.createElement("span");
    lineBreakSpan.innerText = "\n\n";
    lineBreakSpan.style.fontSize = `${12}pt`;
    lineBreakSpan.style.color = useRGBToHex(commentColor);
    lineBreakSpan.style.textAlign = "left";

    container.appendChild(lineBreakSpan);
  }

  return container;
};
